import { create } from "zustand";
import cartSlice from "./slices/cartSlice";

const useCartStore = create((set, get) => ({
  ...cartSlice(set, get),
}));

export { useCartStore };
